








import Vue from "vue";
import { Action } from "@/constants/ajax";

export default Vue.extend({
  name: "SubmitButton",
  props: {
    action: Number,
    data: {
      type: Object,
      default: {},
    },
    disabled: Boolean,
    buttonValue: {
      type: String,
      default: "",
    },
    beforeSubmit: {
      type: Function,
      // tslint:disable-next-line: no-empty
      default: (): void => {},
    },
  },
  data() {
    return {
      isSubmitting: false,
    };
  },
  methods: {
    submitForm(action: Action): void {
      const t: any = this;
      // noinspection TypeScriptValidateJSTypes
      this.isSubmitting = true;

      t.beforeSubmit();

      (this as any).$store
        .dispatch("ajax", {
          action: t.action,
          data: t.data,
        })
        .finally(() => {
          this.isSubmitting = false;
        });
      (this as any).$emit("click");
    },
  },
});
